module.exports = __webpack_public_path__ + "static/media/right-arrow-white.55444d0d.svg";